<template>
    <div :class="css.container" ref="container" v-on="ons.drag" v-show="visible">
        <div :class="css.controls" ref="control">
            <ui-icon :class="css.control" :name="reduce ? 'enlarge' : 'reduce'" @click="reduce = !reduce" />
            <ui-icon :class="css.control" name="close2" @click="visible = false" />
        </div>
        <div v-if="reduce" :class="css.name" class="font-bold color-1">{{ $t("CodonChart") }}</div>
        <div v-else>
            <div :class="css.text" class="font-bold color-1">{{ $t("SecondBaseInCodon") }}</div>
            <div style="position: relative">
                <div :class="[css.text, css.first]" class="font-bold color-1">{{ $t("FirstBaseInCodon") }}</div>
                <div :class="[css.text, css.last]" class="font-bold color-1">{{ $t("LastBaseInCodon") }}</div>
                <img :class="css.img" src="https://rdgta.cdn.cyagen.com/rddc/images/tool/variant/codon2.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const { refs, nodes, methods, ons } = useComposable();
const { open, close } = methods;
const { container, control } = nodes;
const { visible, reduce } = refs;

//* 组件属性导出
defineExpose({ open, close });
</script>
